import ApiClient from "../helpers/ApiClient";






export const editData = async ({ id, title, subtitle, file}) => {

    try {
        const response = await ApiClient.put(`/Careers/updateCareerHeader/${id}`,
            { id, title, subtitle, file},
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
        console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}


export const getData = async () => {
    try {
        const response = await ApiClient.get(`/Careers/getCareerHeader`);
        console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}

// export const deleteData = async ({ id }) => {
//     try {
//         const response = await ApiClient.put(`//${id}`);
//         console.log("response", response);
//         return response;
//     } catch (error) {
//         throw error;
//     }
// }
